import { useSelector } from 'react-redux'
import TicketsScannerTicketNotFound from './TicketNotFound'
import TicketsScannerTicketOwnerInfo from './TicketOwnerInfo'
import TicketsScannerTicketHistory from './TicketHistory'
import { selectTicket } from '../../stores/ticketsScanner/actions'

const TicketsScannerTicketData = () => {
  const ticket = useSelector(selectTicket)
  
  let ticketView

  if (ticket) {
    if (ticket.notFound) {
      ticketView = <TicketsScannerTicketNotFound />
    } else {
      ticketView = (
        <div>
          <TicketsScannerTicketOwnerInfo ticket={ticket} />
          <TicketsScannerTicketHistory ticket={ticket} />
        </div>
      )
    }
  }

  return <div>{ticketView}</div>
}

export default TicketsScannerTicketData
